import { stringify } from 'qs';
import { fork, put, takeLatest, select } from 'redux-saga/effects';

import { getCountryCode } from '@lendingAPI/lendingAPISelector';
import { getQueryParams } from '@src/helpers/helpers';

import {
    AUTOMATED_LENDING_DECISION_CHANGE_APPLICATION_STEP,
    EDIT_ADDITIONAL_GUARANTOR
} from './AutomatedLendingDecision.actions';
import { nextStep } from '../../actions';
import { EDIT_GUARANTOR } from '../AdditionalGuarantor/AdditionalGuarantor.actions';
import { getGuarantors } from '../AdditionalGuarantor/AdditionalGuarantor.sagas';
import { CANCEL_GET_LOAN_DECISION } from '../LoanDecision/LoanDecision.actions';
import { CLOSE_MODAL } from '../Modals/Modals.actions';
import { convertActiveStepIdToStepPathName } from '../Routes/helper/stepActiveIds.helper';
import { navigateTo } from '../Routes/Navigation.action';
import { getBasePath } from '../Routes/Navigation.selector';

function* automatedLendingDecisionSwitchApplicationStepSaga() {
    yield takeLatest(
        AUTOMATED_LENDING_DECISION_CHANGE_APPLICATION_STEP,
        function* ({ step }) {
            const isUKLocale = yield select(
                (state) => getCountryCode(state) === 'uk'
            );

            const basePath = yield select((state) => getBasePath(state));
            const pathname = convertActiveStepIdToStepPathName(
                step,
                isUKLocale
            );
            const urlQueryParams = stringify(getQueryParams());

            yield put(nextStep(step));
            yield put(
                navigateTo(
                    `${basePath}/${pathname}${
                        urlQueryParams ? `?${urlQueryParams}` : ''
                    }`
                )
            );
            yield put({ type: CLOSE_MODAL });
            yield put({
                type: CANCEL_GET_LOAN_DECISION
            });
        }
    );
}

function* automatedLendingDecisionEditGuarantorSaga() {
    yield takeLatest([EDIT_ADDITIONAL_GUARANTOR], function* () {
        const guarantors = yield* getGuarantors();
        const firstGuarantorUID = (guarantors[0] && guarantors[0].uid) || null;

        yield put({
            type: EDIT_GUARANTOR,
            uid: firstGuarantorUID
        });
        yield put({
            type: CANCEL_GET_LOAN_DECISION
        });
    });
}

export default [
    fork(automatedLendingDecisionSwitchApplicationStepSaga),
    fork(automatedLendingDecisionEditGuarantorSaga)
];
